const styles = () => ({
  logoAnchor: {
    width: 186.077,
    height: 28.365
  }
});

export default styles;
